import { CopyOutlined } from "@ant-design/icons";
import { Button, Divider, Grid, Skeleton, Tooltip, Typography, message, Modal } from 'antd';
import { observer } from "mobx-react-lite";
import * as React from "react";
import { useEffect } from "react";
import { useStore } from "../../root-store-context";
import { WeekInfoContent } from "./WeekInfoContent";
import { LOCKED_WEEK_MSG } from "../../constants/catMessages";

const { Text } = Typography;
const { useBreakpoint } = Grid;

export const WeekInfo = observer(() => {
    const {
        userWeeklyLogStore: { selectedCatWeek, isLoading, isSubmitButtonDisabled, isOutsideEditingWindow, setSelectedWeek, saveEntries, getWeeklyLog, copyLastWeek },
        userWeekStore: { catWeekList, getWeeksForUser }
    } = useStore();

    const screens = useBreakpoint();
    const isMobile = !screens.xl;

    const [messageApi, contextHolder] = message.useMessage();

    const success = () => {
        getWeeksForUser();
        getWeeklyLog(selectedCatWeek.id);
        Modal.success({ content: 'Information of the week sent successfully' });
    };

    const error = () => {
        messageApi.open({
            type: 'error',
            content: 'An error occurred while sending information, try reloading the page and trying again',
        });
    };

    useEffect(() => {
        if ((selectedCatWeek.id == null || selectedCatWeek.id == 0) && catWeekList.length > 0) {
            setSelectedWeek(catWeekList[0]);
        }
    }, [catWeekList])

    const isSelectedCatWeekEmpty = () => (selectedCatWeek.id == null || selectedCatWeek.id == 0);

    return (
        <>
            {contextHolder}
            {!isSelectedCatWeekEmpty() ? (
                <div className="cat-week-info">

                    <div className="cat-week-info__header">
                        <span className="cat-week-info__header-title">Week #{selectedCatWeek.week}</span>
                        <span className="cat-week-info__header-date">
                            {selectedCatWeek.firstDayStr} - {selectedCatWeek.lastDayStr}
                        </span>
                    </div>

                    <Divider style={{ margin: 0 }} />

                    <WeekInfoContent />

                    <Divider style={{ margin: 0 }} />

                    {isSubmitButtonDisabled && (
                        <div style={{ textAlign: isMobile ? "left" : "right" }}>
                            <Text type="danger">If you're trying to add more than 40 hrs, click Edit Hours</Text>
                        </div>
                    )}

                    <div className="cat-week-info__actions">
                        <Tooltip title={isOutsideEditingWindow ? LOCKED_WEEK_MSG : undefined}>
                            <Button
                                data-testid="cat-btn-copy-previous-week"
                                className="cat-week-info__copy-btn"
                                size={isMobile ? "large" : "middle"}
                                block={isMobile}
                                disabled={isLoading || isOutsideEditingWindow}
                                icon={isMobile ? <CopyOutlined /> : undefined}
                                onClick={() => copyLastWeek()}
                            >
                                Copy previous completed week
                            </Button>
                        </Tooltip>
                        <Tooltip title={isOutsideEditingWindow ? LOCKED_WEEK_MSG : undefined}>
                            <Button
                                data-testid="cat-btn-submit"
                                size={isMobile ? "large" : "middle"}
                                block={isMobile}
                                type="primary"
                                disabled={isLoading || isSubmitButtonDisabled || isOutsideEditingWindow}
                                onClick={() =>
                                    saveEntries()
                                        .then(res => res ? success() : error())
                                        .catch(() => error())
                                }
                            >
                                Submit
                            </Button>
                        </Tooltip>
                    </div>

                </div>
            ) : (
                <Skeleton />
            )}
        </>
    );
})